<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Nachschreibeklausuren</v-card-title>
      <v-tabs v-model="tab">
        <v-tab>Meine Nachschreiber</v-tab>
        <v-tab>Nachschreibetermin</v-tab>
      </v-tabs>
    </v-card>
    <br>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <missing-exam-table
            :exams="myExams"
            :loading="loadingMine"
            no-data-text="Keine versäumten Klausuren in Ihren Klausuren"/>
      </v-tab-item>
      <v-tab-item>
        <retake-attendance/>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {useHttp} from "@/core/http";
import {MissingExam} from "@/core/models/missing-exam";
import MissingExamTable from "@/components/missingExams/MissingExamTable.vue";
import RetakeAttendance from "@/components/missingExams/RetakeAttendance.vue";

@Component({
  components: {MissingExamTable, RetakeAttendance},
})
export default class MissingExams extends Vue {
  private tab = 0
  private myExams: Array<MissingExam> = []
  private loadingMine = false

  private http = useHttp()

  private mounted() {
    this.loadMine()
  }

  private loadMine(): Promise<void> {
    this.loadingMine = true

    return this.http.get('missing-exams/mine')
        .then((data: any) => {
          this.myExams = data.data
        })
        .catch(() => this.notifyError())
        .finally(() => {
          this.loadingMine = false
        })
  }

  private notifyError(): void {
    this.$notify({
      title: 'Fehler',
      type: 'error',
      text: 'Die Nachschreibeklausuren konnten nicht geladen werden.',
    })
  }
}
</script>
